import { render, staticRenderFns } from "./AssignorAdd.vue?vue&type=template&id=44215046&"
import script from "./AssignorAdd.vue?vue&type=script&lang=js&"
export * from "./AssignorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports